import axios from 'axios'

import { reatailmediaApi as baseAPI } from '../../api'

const baseURL = `${baseAPI}/configuration`

export const getPublisherConfigurationKey = 'getPublisherConfiguration'

export const getPublisherConfigurationService = (publisherId?: string) =>
  axios.get<PublisherConfiguration>(`${baseURL}/v2/publisher/`, {
    params: {
      publisher_id: publisherId
    }
  })

export const getPublisherDestinationUrlsService = (publisherId?: string, campaignId?: string) =>
  axios.get<PublisherConfigurationDestinationUrls>(`${baseURL}/destinations`, {
    params: {
      publisher_id: publisherId,
      campaign_id: campaignId
    }
  })
